import { render } from "./page-planning-livraison.vue?vue&type=template&id=04454d9f"
import script from "./page-planning-livraison.vue?vue&type=script&lang=js"
export * from "./page-planning-livraison.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Web apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__